export const locale = {
    lang: 'en',
    data: {
        FORM_DYNAMIC: {
            DATE_FORMAT: 'MM/dd/yyyy',
        },
    },
};
